import {
    all,
    fork,
    takeEvery,
    call,
    put,
} from 'redux-saga/effects';
import { types, actions } from './reducer';
import { extractError } from '@iso/lib//helpers/api';
import UserService from '@iso/services/AccountService/UserService';

function* viewUser({ id }) {
    try {
        const response = yield call(UserService.getOne, id);
        yield put(actions.viewUserSucceeded(response.data));
    } catch (error) {
        yield put(actions.viewUserFailed(extractError(error)));
    }
}

function* watchViewUser() {
    yield takeEvery(
        types.REQUEST_VIEW_USER,
        viewUser,
    );
}

function* viewSaga() {
    yield all([
        fork(watchViewUser),
    ]);
}

export default viewSaga;
